<template>
  <div
    :class="['imgSize',!hasLastOne?hasBottom:'']"
    v-if="itemAd.imageUrl"
    :clstag="'jr|keycount|8530052_index_ad_'+index+'|'+itemAd.id+''"
  >
    <KPL
      ref="kplIns"
      :url="itemAd.jumpInfo && itemAd.jumpInfo.jumpUrl"
      class="imageLink"
    >
      <img
        :src="itemAd.imageUrl"
        alt=""
        class="imgSizeInner"
      />
    </KPL>
  </div>
</template>
<script>
import KPL from '@/buscomponents/KPL.vue';

export default {
  name: 'SmallFloatingLayer',
  components: {
    KPL
  },
  props: {
    itemAd: {
      default: () => {
        return {
          imageUrl: '',
          jumpInfo: {
            jumpType: '8',
            jumpUrl: '',
            pageType: '0'
          }
        };
      }
    },
    itemId: '',
    imgSize: {
      type: String,
      default: () => {
        return 'imgSizeStyle';
      }
    },
    hasLastOne: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      floatWrap: 'floatWrapStyle',
      hasBottom: 'hasBottom'
    };
  },
  destroyed() {
    this.$refs.kplIns = null;
  }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.imgSizeStyle {
  width: 100%;
  overflow: hidden;
  margin-bottom: $rem20;
}

.imageLink {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.imgSizeInner {
  width: 100%;
  height: auto;
}

.hasBottom {
  margin-bottom: $rem20;
}
</style>
